export const EMAIL_TEMPLATES = {
  payoutRequestAdmin: 'payoutRequestAdmin',
  payoutRequestArtist: 'payoutRequestArtist',
  creatorApprovedWithSubmissions: 'creatorApprovedWithSubmissions',
  creatorApproved: 'creatorApproved',
  creatorDisabled: 'creatorDisabled',
  creatorEmailVerify: 'creatorEmailVerify',
  creatorRejected: 'creatorRejected',
  passwordReset: 'passwordReset',
  submissionApproved: 'submissionApproved',
  submissionMultiple: 'submissionMultiple',
  submissionRejected: 'submissionRejected',
  reportUser: 'reportUser',
  reportContent: 'reportContent',
  userDeleteRequest: 'userDeleteRequest',
} as const;
